import axios from 'axios'
import { toastr } from 'react-redux-toastr'

import { URL } from '../../assets/js/constants'

export function carregarCategorias(data) {
    return {
        type: 'CATEGORIAS_FETCHED',
        payload: data
    }
}

export function carregarCategoria(data) {
    return {
        type: 'CATEGORIA_FETCHED',
        payload: data
    }
}

export function categoriaLoading(data) {
    return {
        type: 'CATEGORIA_LOADING',
        payload: data
    }
}

export function getCategoria(value) {
    return dispatch => {
        dispatch(categoriaLoading(true));
        axios.get(`${URL}/categorias/reduzido/${value}`)
            .then(resp => {
                dispatch(carregarCategoria(resp.data));
                dispatch(categoriaLoading(false));
            })
            .catch(e => {
                dispatch(categoriaLoading(false));
                toastr.error('Erro', e.message);
            })
    }
}

export function getCategoriasAtivas(idNegocio) {
    return dispatch => {
        axios.get(`${URL}/categorias/meu-negocio/ativas/${idNegocio}`)
            .then(resp => {
                dispatch(carregarCategorias(resp.data));
            })
            .catch(e => {
                toastr.error('Erro', e.message);
            })
    }
}

export function getCategoriasDoNegocio(idNegocio) {
    return dispatch => {
        axios.get(`${URL}/categorias/listar-reduzido/meu-negocio/${idNegocio}`)
            .then(resp => {
                dispatch(carregarCategorias(resp.data));
                dispatch(categoriaLoading(false));
            })
            .catch(e => {
                dispatch(categoriaLoading(false));
                toastr.error('Erro', e.message);
            })
    }
}

export function addCategoria(values) {
    return dispatch => {
        axios.post(`${URL}/categorias`, values)
            .then(_ => dispatch(toastr.success('Sucesso', 'Categoria cadastrada com sucesso.')))
            .catch(e => {
                try {
                    const data = e.response.data;
                    if (typeof data !== 'undefined') {
                        const { status, msg, errors } = data;
                        if (status === 400) {
                            errors.forEach(erro => {
                                toastr.error(msg, 'Campo: ' + erro.fieldName + '. ' + erro.message);
                            })
                        } else {
                            toastr.error(msg, 'Erro: ' + status);
                        }
                    }
                } catch (e) {
                    return false;
                }
            })
    }
}

export function editCategoria(value) {
    return dispatch => {
        axios.put(`${URL}/categorias`, value)
            .then(_ => dispatch(toastr.success('Sucesso', 'Categoria cadastrada com sucesso.')))
            .catch(e => {
                try {
                    const data = e.response.data;
                    if (typeof data !== 'undefined') {
                        const { status, msg, errors } = data;
                        if (status === 400) {
                            errors.forEach(erro => {
                                toastr.error(msg, 'Campo: ' + erro.fieldName + '. ' + erro.message);
                            })
                        } else {
                            toastr.error(msg, 'Erro: ' + status);
                        }
                    }
                } catch (e) {
                    return false;
                }
            })
    }
}

export function deletarCategoria(value) {
    return dispatch => {
        axios.delete(`${URL}/categorias/deletar/${value.id}`)
            .then(_ => dispatch(getCategoriasDoNegocio(value.idNegocio)))
            .then(_ => dispatch(toastr.success('Sucesso', 'Categoria excluída com sucesso!')))
            .catch(e => {
                try {
                    const { msg } = e.response.data;
                    toastr.error('Erro', msg);
                } catch (e) {
                    return false;
                }
            }
            )
    }
}